module.exports = __webpack_public_path__ + "display/static/img/icon-a.843c03e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/tui-image-editor/dist/svg/icon-a.svg
// module id = 771
// module chunks = 1 3